import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://admin.local.dev:8080'}/api`;

class ShopService {
  async list() {
    const response = await axios.get(`${API_URL}/platform/shops/list`);
    return response.data.data || [];
  }

  async updateDirectPurchase(id, directPurchase) {
    const response = await axios.post(`${API_URL}/platform/shops/update/${id}`, {
      directPurchase,
    });
    return response.data.data;
  }
}

const shopService = new ShopService();

export default shopService;
